import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';

enum ItemType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TERTIARY = 'TERTIARY',
}

export interface Props {
  title: any;
  type?: ItemType;
  theme?: any;
  hoverItems?: any;
  url?: string;
  onClick?: any;
}

function MobileNavItem({ title, type, theme, url, onClick }: Props) {
  const loadColorBasedOnItemType = () => {
    switch (type) {
      case ItemType.PRIMARY: {
        return theme.colors.primary;
      }
      case ItemType.SECONDARY: {
        return theme.colors.primary;
      }
      case ItemType.TERTIARY: {
        return theme.colors.textPrimary;
      }
      default: {
        return theme.colors.primary;
      }
    }
  };

  const loadFontWeightBasedOnItemType = () => {
    switch (type) {
      case ItemType.PRIMARY: {
        return 400;
      }
      case ItemType.SECONDARY: {
        return 300;
      }
      case ItemType.TERTIARY: {
        return 300;
      }
      default: {
        return 400;
      }
    }
  };

  const loadDisplayBasedOnItemType = () => {
    switch (type) {
      case ItemType.PRIMARY: {
        return 'inline-block';
      }
      case ItemType.SECONDARY: {
        return 'flex';
      }
      case ItemType.TERTIARY: {
        return 'flex';
      }
      default: {
        return 'inline-block';
      }
    }
  };

  const loadBgColorBasedOnItemType = () => {
    switch (type) {
      case ItemType.PRIMARY: {
        return theme.colors.hover;
      }
      case ItemType.SECONDARY: {
        return theme.colors.hover;
      }
      case ItemType.TERTIARY: {
        return 'transparent';
      }
      default: {
        return theme.colors.hover;
      }
    }
  };

  const color = loadColorBasedOnItemType();
  const fontWeight = loadFontWeightBasedOnItemType();
  const display = loadDisplayBasedOnItemType();
  const backgroundColor = loadBgColorBasedOnItemType();

  return (
    <Wrapper
      to={url}
      display={display}
      fontWeight={fontWeight}
      color={color}
      onClick={onClick}
      bgColor={backgroundColor}
    >
      {title}
    </Wrapper>
  );
}

interface WrapperProps {
  color: any;
  fontWeight: any;
  display: string;
  bgColor: string;
}

const Wrapper = styled(Link)`
  text-decoration: none;
  padding: ${rem(24)} ${rem(16)};
  color: ${({ color }: WrapperProps) => color};
  background-color: ${({ bgColor }: WrapperProps) => bgColor};
  font-weight: ${({ fontWeight }: WrapperProps) => fontWeight};
  line-height: ${rem(22)};
  font-size: 14px;
  border-bottom: ${({ theme }) => theme.borders.primary};

  display: ${({ display }: WrapperProps) => display};
  align-items: flex-end;
  position: relative;

  &:first-child {
    border-top: ${({ theme }) => theme.borders.primary};
  }
`;

const withThemeMobileNavItem: any = withTheme(MobileNavItem);
export { withThemeMobileNavItem as MobileNavItem, ItemType };
